module.exports = __webpack_public_path__ + "img/logos_discord-icon.3aa8662c.svg";